<template>
  <div class="question-input-rank-order">
    <!-- Old version using Buefy
    <b-table
      :data='tableData'
      :columns='columns'
      draggable
      @dragstart='dragstart'
      @drop='drop'
      @dragover='dragover'
      @dragleave='dragleave'>
    </b-table>
    -->

    <div class="is-flex gap-1">
      <div class="p-1 basis-0 grow is-flex-col">
        <div class="text-center bold pb-2">
          Available Goals
        </div>

        <draggable
          v-model="availableChoices"
          group="group"
          class="grow"
        >
          <div
            v-for="choice in availableChoices"
            :key="choice.text"
            class="drag-item py-1 px-2 mb-2 border-rad-1-4"
            :style="{ backgroundColor: colors.gray[5] }"
          >
            {{ choice.text }}
          </div>
        </draggable>
      </div>


      <div class="p-1 basis-0 grow is-flex-col">
        <div class="text-center bold pb-2">
          Our Goals
        </div>

        <draggable
          v-model="selectedChoices"
          group="group"
          class="grow"
          @change="sendAnswer()"
        >
          <div
            v-for="(choice, i) in selectedChoices"
            :key="choice.text"
            class="drag-item mb-2 flex align-center border-rad-1-4"
            :style="{ backgroundColor: colors.primary[4] }"
          >
            <div
              class="grow py-1 px-2"
              :style="{ backgroundColor: colors.primary[5], borderRadius: '0.25em 0 0 0.25em' }"
            >
              {{ choice.text }}
            </div>

            <div
              class="bold text-center"
              :style="{ flexBasis: '1.5em', minWidth: '1.5em' }"
            >
              {{ i + 1 }}
            </div>
          </div>
        </draggable>
      </div>
    </div>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'
import draggable from 'vuedraggable';


export default {
  name: 'ComponentName',
  components: { draggable },
  props: ['choices', 'prevAnswer'],
  data() {
    return {
      availableChoices: [],
      selectedChoices: [],
      columns: [{
        field: 'text',
        label: 'Goals',
      }],
      draggingChoice: null,
      fromIndex: null,
      toIndex: null,
    };
  },
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    colors() {
      return this.$root.$data.COLORS;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {
  },
  mounted() {
    this.availableChoices = this.choices.map(c => {
      const isString = typeof c === 'string';
      const choice = isString ? { text: c } : c;
      return { id: Math.random(), ...choice };
    });

    if (this.prevAnswer) {
      // @NiftyOctopus- not sure how this should fit in with the rest of the code
      // would be nice if we send the whole answer to the backend as opposed to just the text
      // such that we can arrange old choices appropriately here
      // this.prevAnswer.forEach(text => {
      //   const choice = this.tableData.find(row => row.text === text);
      // })
    }
  },
  updated() {},
  methods: {
    /* Old version using Buefy
    dragstart(payload) {
      this.draggingChoice = payload.row;
      this.fromIndex = payload.index;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.toIndex = payload.index;
      this.moveChoice();
    },
    moveChoice() {
      // Copy the choice row and assign a new id
      // Ensures we only delete the instance in the old spot
      const choice = { ...this.draggingChoice, id: Math.random() };

      // Determine if choice should be inserted before or after target index
      // Ensures that the dragging choice ends up at the cursor afterwards
      const down = this.toIndex > this.fromIndex;
      const offset = down ? 1 : 0;

      this.tableData.splice(this.toIndex + offset, 0, choice);
      this.removeChoiceByID(this.draggingChoice.id);
      this.sendAnswer();
    },
    removeChoiceByID(id) {
      const newTableData = this.tableData.filter(choice => choice.id !== id);
      this.tableData = [...newTableData];
    },
    */
    sendAnswer() {
      const data = this.selectedChoices.map(choice => choice.text);
      this.$emit('answered', data);
    },
  },
};
</script>


<style scoped>
.drag-item:hover {
  cursor: grab;
}
</style>


<style>
/*
.question-input-rank-order .table-wrapper {
  min-height: 0;
}
.question-input-rank-order .table tr {
  transition: background-color 250ms ease-out, color 250ms ease-out;
}
*/
</style>
